import React, { useEffect } from "react";

const ContactFormInfo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="p-4 bg-gray-100">
      <h1 className="text-2xl font-bold text-center mb-4">
        İLETİŞİM FORMU AYDINLATMA METNİ
      </h1>
      <p className="mb-4">
        Aşağıda yer alan{" "}
        <strong>Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni</strong>
        ’ni okuyarak kişisel verilerinizi işleme amacımızı ve bu kapsamda
        haklarınızı ayrıntılarıyla incelemenizi rica ediyoruz.
      </p>

      <h2 className="text-lg font-semibold mb-2">a) Veri Sorumlusu</h2>
      <p className="mb-4">
        6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) uyarınca,
        kişisel verileriniz; veri sorumlusu olarak
        <strong>
          {" "}
          LENSA Sanayi ve Ticaret Anonim Şirketi
          (“Şirket”)
        </strong>{" "}
        tarafından aşağıda açıklanan kapsamda işlenecektir.
      </p>

      <h2 className="text-lg font-semibold mb-2">
        b) Kişisel Verilerin İşlenme Amaçları, Toplama Yöntemleri ve Hukuki
        Sebepleri
      </h2>
      <div className="overflow-x-auto mb-4">
        <table className="min-w-full table-auto border-collapse border border-gray-200">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 px-4 py-2">
                İşlemeye Konu Kişisel Veri Kategorileri ve Tipleri
              </th>
              <th className="border border-gray-300 px-4 py-2">
                Kişisel Verilerinizin Hangi Amaçlarla İşleneceği
              </th>
              <th className="border border-gray-300 px-4 py-2">
                Kişisel Verilerinizin Hangi Yöntemle Toplandığı ve Hukuki Sebebi
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2">
                Kimlik Bilgisi: İsim, Soyisim
              </td>
              <td className="border border-gray-300 px-4 py-2">
                İletişim Faaliyetlerinin Yürütülmesi, Talep / Şikayetlerin
                Takibi, İş Süreçlerinin İyileştirilmesine Yönelik Önerilerin
                Alınması Ve Değerlendirilmesi, Mal / Hizmet Satış Sonrası Destek
                Hizmetlerinin Yürütülmesi, Müşteri Memnuniyetine Yönelik
                Aktivitelerin Yürütülmesi, Müşteri İlişkileri Yönetimi
                Süreçlerinin Yürütülmesi
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Web sitesinde bulunan İletişime Geç formları üzerinden otomatik
                yollarla toplanan kişisel verileriniz KVKK’nın 5. maddesinde
                belirtilen “İlgili kişinin temel hak ve özgürlüklerine zarar
                vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri
                işlenmesinin zorunlu olması.” hukuki sebebine dayanarak
                işlenmektedir.
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">
                İletişim Bilgisi: E-Posta Adresiniz, Cep Telefonu
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Talep / Şikayetlerin Takibi, İş Süreçlerinin İyileştirilmesine
                Yönelik Önerilerin Alınması Ve Değerlendirilmesi, Mal / Hizmet
                Satış Sonrası Destek Hizmetlerinin Yürütülmesi, Müşteri
                Memnuniyetine Yönelik Aktivitelerin Yürütülmesi, Müşteri
                İlişkileri Yönetimi Süreçlerinin Yürütülmesi, İletişim
                Faaliyetlerinin Sürdürülmesi
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Web sitesinde bulunan İletişime Geç formları üzerinden otomatik
                yollarla toplanan kişisel verileriniz KVKK’nın 5. maddesinde
                belirtilen “İlgili kişinin temel hak ve özgürlüklerine zarar
                vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri
                işlenmesinin zorunlu olması.” hukuki sebebine dayanarak
                işlenmektedir.
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-4 py-2">
                Diğer-Kullanıcı İşlem Bilgileri: Mesajınız
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Talep / Şikayetlerin Takibi, İş Süreçlerinin İyileştirilmesine
                Yönelik Önerilerin Alınması Ve Değerlendirilmesi, Mal / Hizmet
                Satış Sonrası Destek Hizmetlerinin Yürütülmesi, Müşteri
                Memnuniyetine Yönelik Aktivitelerin Yürütülmesi, Müşteri
                İlişkileri Yönetimi Süreçlerinin Yürütülmesi
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Web sitesinde bulunan İletişime Geç formları üzerinden otomatik
                yollarla toplanan kişisel verileriniz KVKK’nın 5. maddesinde
                belirtilen “İlgili kişinin temel hak ve özgürlüklerine zarar
                vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri
                işlenmesinin zorunlu olması.” hukuki sebebine dayanarak
                işlenmektedir.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 className="text-lg font-semibold mb-2">
        c) İşlenen Kişisel Verilerinizin Kimlere ve Hangi Amaçlarla
        Aktarılabileceği
      </h2>
      <p className="mb-4">
        Kişisel verileriniz; aşağıda yer verilen üçüncü taraflara ve belirtilen
        amaçlarla aktarılabilecektir:
      </p>
      <div className="overflow-x-auto mb-4">
        <table className="min-w-full table-auto border-collapse border border-gray-200">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 px-4 py-2">
                Yurt İçinde Yerleşik Üçüncü Taraf
              </th>
              <th className="border border-gray-300 px-4 py-2">
                Aktarıma Konu Olabilecek Kişisel Veri Kategorileri ve Tipleri
              </th>
              <th className="border border-gray-300 px-4 py-2">
                Aktarım Amacı
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 px-4 py-2">
                Yetkili kamu kurum ve kuruluşları (Uyuşmazlık olması veya
                doğrudan yetkili kişi, kurum veya kuruluşlardan talep edilmesi
                halinde)
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Yukarıda b) bölümünde sayılan verilerin tamamı
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Yetkili Kişi, Kurum Ve Kuruluşlara Bilgi Verilmesi
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 className="text-lg font-semibold mb-2">
        d) İlgili Kişi Olarak KVKK Kapsamındaki Haklarınızla İlgili
        Bilgilendirme
      </h2>
      <p>
        İlgili Kişi olarak, KVKK’nın ilgili kişinin haklarını düzenleyen 11.
        maddesi kapsamındaki taleplerinizi Veri Sorumlusuna Başvuru Usul ve
        Esasları Hakkında Tebliğ’e göre{" "}
        <strong>
          Kaptanpaşa Mahallesi Halit Ziya Türkkan Sokak Famas Plaza C-Blok
          No:19/3 Şişli
        </strong>{" "}
        adresine yazılı olarak iletebilir veya{" "}
        <a href="mailto:kvkk@lensa.com.tr" className="text-blue-600 underline">
          kvkk@lensa.com.tr
        </a>{" "}
        e-posta adresine elektronik ortamda gönderebilirsiniz.
      </p>
    </div>
  );
};

export default ContactFormInfo;
